import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const GoogleCallback = () => {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", location.pathname);
    api.post("/auth/google", { session_id: sessionId })
      .then(({ data }) => {
        if (data.finish_required) { setUser(false); return nav("/join/finish", { replace: true, state: data }); }
        setUser(data.user);
        toast.success("Welcome back");
        nav("/dashboard", { replace: true });
      })
      .catch((e) => { setUser(false); toast.error(formatApiError(e)); nav("/login", { replace: true }); });
  }, [location, nav, setUser]);

  return <div data-testid="google-callback" className="min-h-screen" />;
};
